module.exports = __webpack_public_path__ + "static/media/debt-mortgage-v4.4edc3d3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/debt-mortgage-v4.svg
// module id = 84
// module chunks = 0